import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { useProfile } from '../hooks/useProfile'
import { getDefaultRoute } from './ProtectedRoute'

export default function RootRedirect() {
  const { user, loading: authLoading } = useAuth()
  const { profile, loading: profileLoading } = useProfile()

  if (authLoading || profileLoading) {
    return <div className="min-h-screen" style={{ background: 'var(--bg-primary)' }} />
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (!profile) {
    return <Navigate to="/onboarding" replace />
  }

  return <Navigate to={getDefaultRoute(profile.role)} replace />
}
